import Header from "./components/header/header.component";
import Propaganda from "./components/propaganda/propaganda.component";
import Table from "./components/table/table.component";
import Ticker from "./components/tickers/tickers.component";
import Description from "./components/description/description.component";
import Footer from "./components/footer/footer.component";

import "./App.scss";

function App() {
  return (
    <div className="App">
      <Header />
      <h1 className="title text-center">Deso Fren</h1>
      {/* <Propaganda /> */}
      <Ticker />
      <Description />
      <Table />
      <Footer />
    </div>
  );
}

export default App;
